export default {
  title_one: 'Ștergi {{count}} modificatori?',
  title_few: 'Ștergi {{count}} modificatori?',
  title_other: 'Ștergi {{count}} modificatori?',
  description: '<strong>{{items}}</strong> vor fi eliminate din meniu',
  buttons: {
    yes: 'Da',
    no: 'Nu',
  },
  toasts: {
    failed_to_delete_modifier_one: 'Eroare la ștergerea modificatorului',
    failed_to_delete_modifier_few: 'Ștergerea modificatorilor a eșuat',
    failed_to_delete_modifier_other: 'Eroare la ștergerea modificatorilor',
    modifiers_got_deleted_one: 'Modificatorul a fost șters',
    modifiers_got_deleted_few: 'Modificatorii au fost șterși',
    modifiers_got_deleted_other: 'Modificatorii au fost șterși',
  },
};
